import { render, staticRenderFns } from "./StudentSpace.vue?vue&type=template&id=6f21eb9a"
import script from "./StudentSpace.vue?vue&type=script&lang=ts"
export * from "./StudentSpace.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports